import { render, staticRenderFns } from "./produceOrderPickers.vue?vue&type=template&id=50a54570&scoped=true"
import script from "./produceOrderPickers.vue?vue&type=script&lang=js"
export * from "./produceOrderPickers.vue?vue&type=script&lang=js"
import style0 from "./produceOrderPickers.vue?vue&type=style&index=0&id=50a54570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a54570",
  null
  
)

export default component.exports